module.exports = __webpack_public_path__ + "img/big1.40803812.png";